import http from "./http";

export function login(data, config = {}) {
  return http.post("/auth/login", data, config);
}

export function getCurrentUser() {
  return http.get("/auth/me");
}

export function logout() {
  return http.post("/auth/logout");
}
